import { useEffect, useRef } from "react";
import { api, logDev } from "@/lib/api";
import { toast } from "sonner";

const SCAN_INTERVAL_MS = 15000;
const SNAPSHOT_WIDTH = 320;

function snapshot(stream) {
  const track = stream?.getVideoTracks?.()[0];
  if (!track || track.readyState !== "live" || !track.enabled) return null;
  const video = snapshot.video || (snapshot.video = Object.assign(document.createElement("video"), { muted: true, playsInline: true }));
  if (video.srcObject !== stream) { video.srcObject = stream; video.play().catch(() => {}); }
  if (!video.videoWidth) return null;
  const canvas = snapshot.canvas || (snapshot.canvas = document.createElement("canvas"));
  canvas.width = SNAPSHOT_WIDTH;
  canvas.height = Math.round((SNAPSHOT_WIDTH * video.videoHeight) / video.videoWidth);
  canvas.getContext("2d").drawImage(video, 0, 0, canvas.width, canvas.height);
  return canvas.toDataURL("image/jpeg", 0.6).split(",")[1];
}

export function useFrameModeration({ active, localStream, camOff }) {
  const warned = useRef(false);
  useEffect(() => {
    if (!active || !localStream || camOff) return;
    let stopped = false;
    const tick = async () => {
      if (stopped) return;
      const b64 = snapshot(localStream);
      if (!b64) return;
      try {
        const { data } = await api.post("/moderation/frame", { image_base64: b64 });
        if (data.action === "warning" && !warned.current) {
          warned.current = true;
          toast.warning("Keep it appropriate — our AI safety check flagged your camera. Repeated flags suspend your account.", { duration: 8000 });
        }
      } catch (e) { logDev("frame scan skipped", e); }
    };
    const first = setTimeout(tick, 4000);
    const iv = setInterval(tick, SCAN_INTERVAL_MS);
    return () => { stopped = true; clearTimeout(first); clearInterval(iv); };
  }, [active, localStream, camOff]);
}
